/**
 * The Bear tab of player detail (spec section 59) reuses the standalone
 * analyzer rather than reimplementing a summary of it, so the two can never
 * disagree about what the same data means.
 */

import { Link } from 'react-router-dom';
import { useBearAnalysis } from '../../../api/queries';
import { QueryBoundary } from '../../../components/ui/states';
import { BearAnalysisView } from '../../bear/PersonalBearAnalyzer';
import { useT } from '../../../i18n';

export function PlayerBearTab({ playerId }: { playerId: string }) {
  const analysis = useBearAnalysis(playerId);
  const t = useT();

  return (
    <div className="stack">
      <p className="muted small" style={{ margin: 0 }}>
        <Link to={`/bear/player/${encodeURIComponent(playerId)}`}>
          {t.bearAnalysis.openFullPage}
        </Link>
      </p>
      <QueryBoundary query={analysis} loadingLabel={t.bearAnalysis.loading}>
        {(data) => <BearAnalysisView result={data} />}
      </QueryBoundary>
    </div>
  );
}
